import React from 'react';
import {TypesContainer,TextInfo, NHSButtonContainer, TagIcon, TagsTabContainer} from '../../styles/styled/tagsStyled';

const Tags = ({options}) => (
            <TagsTabContainer>
              <TextInfo> Tag your blessings to help other people find them, and share them</TextInfo>
              <TextInfo subText>You can choose up to 2 tags from any of the following:</TextInfo>
                {
                options && options.map((item, index) => (
                   <TypesContainer key={item.id}>
                    <NHSButtonContainer className="col-5" dropDownColor={item.categoryIconColour}>
                       <TagIcon icon={item.fontAwesomeIcon}/>
                        {item.tagText}
                    </NHSButtonContainer>
                    <TextInfo subText>{item.description}</TextInfo>
                   </TypesContainer>
                  ))
                }
            </TagsTabContainer>
         );

export default Tags;
